import { Logger } from '@kulee/helper'
import { LOGGER_LEVEL, LOGGER_PREFIX } from '@/config/constant'

const logger = new Logger(LOGGER_PREFIX, LOGGER_LEVEL)

export default logger
